<!--
 * @Author:
 * @LastEditTime: 2023-08-30
 * @Description: 设备四色图
-->
<template>
  <el-card class="h-full relative">
    <div class="h-full flex flex-col">
      <!-- <el-carousel trigger="click" class="h-[calc(100%-40px)]" height="100%" :autoplay="false">
        <el-carousel-item v-for="(item, index) in dataList" :key="index">
          <div class="flex flex-col h-full w-full">
            <iframe
              :ref="'htFrame' + index"
              class="flex-auto h-0px"
              src="/static/ht/htView.html"
              @load="iframeOnload(item, 'htFrame' + index)"
            ></iframe>
            <div class="my-10px text-center">{{ item.name }}</div>
          </div>
        </el-carousel-item>
      </el-carousel> -->
      <el-row class="h-[calc(100%-40px)]">
        <el-col class="h-full flex justify-center items-center" :span="1">
          <el-button
            :disabled="currentDataIndex === 0 || _.isEmpty(currentDataInfo)"
            class="w-26px h-39px p-0"
            size="mini"
            type="primary"
            icon="iconfont icon-line-left"
            @click="togglePicture('last')"
          ></el-button>
        </el-col>
        <el-col
          v-loading="pictureLoading && isHtLoading"
          class="h-full flex justify-center items-center flex-col"
          :span="22"
        >
          <iframe
            ref="htFrame"
            class="h-0px w-full flex-auto"
            src="/static/ht/htView.html"
            @load="iframeOnload"
          ></iframe>
          <div class="text-center">{{ currentDataInfo.name }}</div>
        </el-col>
        <el-col class="h-full flex justify-center items-center" :span="1">
          <el-button
            :disabled="currentDataIndex === totalCount - 1 || _.isEmpty(currentDataInfo)"
            class="w-26px h-39px p-0"
            size="mini"
            type="primary"
            icon="iconfont icon-line-right"
            @click="togglePicture('next')"
          ></el-button>
        </el-col>
      </el-row>
      <div class="flex-auto h-0 flex justify-center items-center">
        <div v-for="(item, index) in colorList" :key="index" class="flex mx-20px">
          <div class="mr-8px h-20px w-40px" :class="item.color"></div>
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { AreaChartApi } from '@wiz-api/area-management'

const areaChartApi = new AreaChartApi()
export default {
  name: 'risk-four-color-chart',
  components: {},
  data() {
    return {
      activeName: 'equipmentList',
      dataList: [],
      colorList: [
        { name: '重大风险', color: 'customebg-color-danger' },
        { name: '较大风险', color: 'customebg-color-alarm' },
        { name: '一般风险', color: 'customebg-color-risk' },
        { name: '低风险', color: 'customebg-color-primary' },
      ],
      currentDataInfo: {}, // 当前加载ht数据信息
      isHtLoading: true, // ht加载状态，初始为加载中
      currentDataIndex: 0, // 当前展示ht数据索引
      totalCount: 0,
      pictureLoading: false,
    }
  },
  methods: {
    // 获取当前数据
    async getListData() {
      this.pictureLoading = true
      const data = {
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [err, res] = await areaChartApi.getList(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
        if (this.dataList.length) {
          this.currentDataInfo = this.dataList[this.currentDataIndex]
          this.iframeOnload()
        }
      }
    },
    // ht加载事件
    iframeOnload(currentDataInfo, key) {
      // 轮播渲染逻辑
      // if (_.isEmpty(currentDataInfo)) {
      //   return
      // }
      // const $window = this.$refs[key][0].contentWindow
      // $window.init(_.get(currentDataInfo, 'fileUrl'))

      // 无ht数据时，不执行ht渲染
      if (_.isEmpty(this.currentDataInfo)) {
        return
      }
      this.isHtLoading = false
      const $window = this.$refs.htFrame.contentWindow
      if ($window && $window.init) {
        $window.init(_.get(this.currentDataInfo, 'fileUrl'))
      }
    },
    // 图片切换
    togglePicture(type = 'last') {
      this.currentDataIndex += type === 'last' ? -1 : 1
      this.currentDataInfo = this.dataList[this.currentDataIndex]
      this.iframeOnload()
    },
  },
  mounted() {
    this.getListData()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}

::v-deep .el-carousel__indicators--horizontal {
  top: 0px;
}

.customebg-color-danger {
  background-color: #ff3a30;
}
.customebg-color-alarm {
  background-color: #ff9502;
}

.customebg-color-risk {
  background-color: #f8b200;
}

.customebg-color-primary {
  background-color: #0082f7;
}
</style>
